import axios from '@/util/axios';

const state = {
    token: null,
    profile: null
};

function checkAccess(state, value) {
    return state.profile.accessProfile.accessGranted
        &&
        ((!state.profile.accessProfile.overrideUserGroupModules && state.profile.accessProfile.userGroupModules.filter(m => m == value).length == 1) ||
            (state.profile.accessProfile.overrideUserGroupModules && state.profile.accessProfile.modules.filter(m => m == value).length == 1))
};

// getters
const getters = {
    profile: (state) => state.profile,
    token: (state) => state.token,
    isLoggedIn: (state) => !!state.token,
    hasAgendaAccess: (state) => !state.token || (!!state.token && checkAccess(state, 1)),
    hasAttendeesAccess: (state) => checkAccess(state, 2),
    hasChatAccess: (state) => checkAccess(state, 3),
    hasTransportAccess: (state) => checkAccess(state, 4),
    hasPartyAccess: (state) => checkAccess(state, 5),

    agendaSettings: (state) => {
        return {
            show: state.profile.showAgenda,
            showDate: state.profile.agendaVisibleFields.filter(e => e == 0).length > 0,
            showTime: state.profile.agendaVisibleFields.filter(e => e == 1).length > 0,
            showAttendees: state.profile.agendaVisibleFields.filter(e => e == 2).length > 0,
            showPartners: state.profile.agendaVisibleFields.filter(e => e == 3).length > 0,
            noAgendaText: state.profile.description.map(e => e.noAgendaText)
        };
    },
    attendeesSettings: (state) => {
        return {
            show: state.profile.showAttendees,
            noAttendeesText: state.profile.description.map(e => e.noAttendeesText)
        };
    },
    partnersSettings: (state) => {
        return {
            displayMode: state.profile.partnersDisplayMode
        };
    }
}

// actions
const actions = {
    async login({ commit, dispatch }, payload) {
        commit('setToken', payload);
        await dispatch('refreshProfile');
    },
    async skip({ commit, dispatch }) {
        commit('setToken', null);
        await dispatch('refreshProfile');
    },
    async logout({ commit, dispatch }) {
        commit('setToken', null);
        commit('setProfile', null);        
        await dispatch('hub/closeChatConnection', null, { root: true });
    },
    async refreshProfile({ commit, dispatch, rootGetters }) {


        await dispatch('conference/init', null, { root: true });
        let currentConf = rootGetters["conference/current"];


        if (!currentConf || !currentConf.visible) {
            //await dispatch('conference/current', null, { root: true });
            await dispatch('logout');
        }

        else {
            let conferenceProfile = (await axios.get('public/conferences/conference/data', {
                params: {
                    year: currentConf.year,
                    type: currentConf.type
                }
            })).data;
            commit('setProfile', conferenceProfile);
        }
    },
    getUserId({ state }) {
        var token = state.token;

        if (token) {
            var base64Url = token.split('.')[1];
            var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            var jsonPayload = decodeURIComponent(atob(base64).split('').map(function (c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));

            var temp = JSON.parse(jsonPayload);
            return parseInt(temp['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier']);
        }
    },
}

// mutations
const mutations = {
    setToken(state, payload) {
        state.token = payload;
    },
    setProfile(state, payload) {
        state.profile = payload;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}